import helpers from "@/helpers";

export default (adminURL, instance) => {
  return {
    getPostsData(payload) {
      return instance
        .post(adminURL + "post/all", payload)
        .catch((error) => helpers.notify.createErrorNotify(error));
    },
    createPost(payload) {
      return instance
        .post(adminURL + "post/create", payload, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then(() => helpers.notify.createUserNotify("success"))
        .catch((error) => {
          helpers.notify.createErrorNotify(error);

          throw error;
        });
    },
    updatePost(id, payload) {
      return instance
        .put(adminURL + `post/${id}`, payload, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then(() => helpers.notify.createUserNotify("success"))
        .catch((error) => {
          helpers.notify.createErrorNotify(error);

          throw error;
        });
    },
    removePost(id) {
      return instance
        .delete(adminURL + `post/${id}`)
        .then(() => helpers.notify.createUserNotify("success"))
        .catch((error) => {
          helpers.notify.createErrorNotify(error);

          throw error;
        });
    },
  };
};
